module.exports = __webpack_public_path__ + "images/travelhome_small8ace796933d50d8c2638f8863762783a.png";